import React from 'react';
import styled from 'styled-components';

export default styled(({ className }) => (
  <svg
    className={className}
    aria-hidden="true"
    focusable="false"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 34 34"
  >
    <path fill="currentColor" d="m27.455 8.075-5.474 4.71-.714-.723-.722-.672 4.692-5.448c.283-.309.678-.49 1.096-.502a1.45 1.45 0 0 1 1.104.46c.29.287.452.68.452 1.087 0 .405-.155.795-.434 1.088zm-1.854 10.736a.33.33 0 0 1 0 .459l-1.112 1.122-.077-.077L13.014 8.917l-.077-.077 1.122-1.113a.322.322 0 0 1 .457-.003l.002.003 3.714 3.706 3.707 3.663 3.662 3.715zM15.14 27.19l-1.352-1.35 2.805-2.797a.854.854 0 0 0-1.207-1.207l-2.796 2.805-6.452-6.452 6.877-6.876 9.001 9.001-6.876 6.877zm13.498-22.49a3.203 3.203 0 0 0-2.296-.96 3.274 3.274 0 0 0-2.345 1.002l-4.658 5.398-3.613-3.621a2.04 2.04 0 0 0-2.873 0l-1.7 1.7a.85.85 0 0 0-.005 1.201l.005.006.68.671L3.74 18.19 15.14 29.59l8.075-8.075.671.68a.85.85 0 0 0 1.202.005l.005-.005 1.7-1.7a2.041 2.041 0 0 0 0-2.873l-3.62-3.613 5.397-4.65h.05a3.25 3.25 0 0 0 .97-2.37 3.2 3.2 0 0 0-.952-2.287z" />
  </svg>
))``;
